import React, { useState } from "react";
import '../css/navbar.css';
import "@fortawesome/fontawesome-free/css/all.min.css";

const menuItems = [
    { name: "🏠︎", link: "/en" },


    {
        name: " University",
        dropdown: [
            { name: "About the University", link: "/en/university/about-university" },
            { name: "Vision & Objectives", link: "/en/university/vision-objectives" },
            { name: "Chancellor's Message", link: "/en/university/chancellor-message" },
            { name: "Vice Chancellor's Message", link: "/en/university/vice-chancellor-message" },
            { name: "Registrar's Message", link: "/en/university/registrar-message" },
            { name: "University Staff", link: "/en/university/university-staff" },
            { name: "University Act", link: "/en/university/university-act" },
            { name: "Anthem", link: "/en/university/anthem" },
            { name: "Campus View", link: "/en/university/campus-view" },
            { name: "Guiding Map", link: "/en/university/guiding-map" },
        ]
    },


    {
        name: "Administration",
        dropdown: [

            {
                name: "Statutory Bodies",
                dropdown: [
                    { name: "Executive Council", link: "/en/administration/statutory-bodies/executive-council" },
                    { name: "Academic Council", link: "/en/administration/statutory-bodies/academic-council" },
                    { name: "Finance Committee", link: "/en/administration/statutory-bodies/finance-committee" },
                    { name: "Academic Planning Board", link: "en/administration/statutory-bodies/academic-planning-board" },
                    { name: "University Court", link: "/en/administration/statutory-bodies/university-court" }
                ]
            },

            {
                name: "University Officials",
                dropdown: [
                    { name: "Chancellor", link: "/en/administration/university-officials/chancellor" },
                    { name: "Vice Chancellor", link: "/en/administration/university-officials/vice-chancellor" },
                    { name: "Registrar", link: "/en/administration/university-officials/registrar" },
                    { name: "Proctor", link: "/en/administration/university-officials/proctor" },
                    { name: "Dean of Academics", link: "/en/administration/university-officials/dean-academics" },
                    { name: "Dean of Student Welfare", link: "/en/administration/university-officials/dean-student-welfare" },
                    { name: "Dean of Colleges", link: "/en/administration/university-officials/dean-colleges" },
                    { name: "Chief Warden", link: "/en/administration/university-officials/chief-warden" },
                    { name: "Finance Officer", link: "/en/administration/university-officials/finance-officer" },
                    { name: "Controller of Examinations", link: "/en/administration/university-officials/controller-examinations" },
                    { name: "Librarian", link: "/en/administration/university-officials/librarian" },
                    { name: "Dean/Faculty Heads", link: "/en/administration/university-officials/dean-faculty-heads" },
                ]
            },

            { name: "Ombudsman", link: "/en/administration/ombudsman" },
            { name: "Offices/Departments", link: "/en/administration/offices-departments" },
            { name: "Special Cells & Committees", link: "/en/administration/special-cells-committees" },


        ]
    },


    {
        name: "Academics",
        dropdown: [
            {
                name: "Faculties & Departments",
                dropdown: [
                    {
                        name: "Veda & Vedanga Faculty",
                        dropdown: [
                            { name: "Veda Department", link: "/en/academics/faculty-departments/veda-vedanga-faculty/veda-department" },
                            { name: "Grammar Department", link: "/en/academics/faculty-departments/veda-vedanga-faculty/grammar-department" },
                            { name: "Astrology Department", link: "/en/academics/faculty-departments/veda-vedanga-faculty/astrology-department" },
                            { name: "Dharma Shastra Department", link: "/en/academics/faculty-departments/veda-vedanga-faculty/dharma-studies-department" },
                        ]
                    },
                    {
                        name: "Literature & Culture Faculty",
                        dropdown: [
                            { name: "Literature Department", link: "/en/academics/faculties-departments/literature-culture/literature-department" },
                            { name: "Hindu Studies Department", link: "/en/academics/faculties-departments/literature-culture/hindu-studies-department" },
                        ]
                    },



                    {
                        name: "Philosophy Faculty",
                        dropdown: [
                            { name: "Philosophy Department", link: "/en/academics/faculty-departments/philosophy-faculty/philosophy-department" },
                            { name: "Yoga Department", link: "/en/academics/faculty-departments/philosophy-faculty/yoga-department" },
                        ]
                    }

                ]
            },

            { name: "Research & Publications", link: "/en/academics/research-publications" },

            {
                name: "Research Centers/Chairs",
                dropdown: [
                    { name: "Saraswati Civilization Research Center", link: "/en/academics/research-center-chairs/saraswati-civilization-research-center" },
                    { name: "Kath-Kapishthal Research Center", link: "/en/academics/research-center-chairs/kath-kapisthala-research-center" },
                    { name: "Maharishi Valmiki Research Center", link: "/en/academics/research-center-chairs/maharishi-valmiki-research-center" },
                    { name: "Indian Knowledge Tradition Research & Training Center", link: "/en/academics/research-center-chairs/indian-knowledge-tradition-research-training-center" },
                    { name: "48 Kos Kurukshetra Pilgrimage Research & Training Center", link: "/en/academics/research-center-chairs/48-kos-kurukshetra-pilgrimage-research-training-center" },
                ]
            },


            {
                name: "Diploma & Other Training Centers",
                dropdown: [
                    { name: "Veda Diploma", link: "/en/academics/diploma-other-training-centers/veda-diploma" },
                    { name: "Vastu Shastra Diploma", link: "/en/academics/diploma-other-training-centers/vastu-shastra-diploma" },
                    { name: "Karmakand/Purohit Diploma", link: "/en/academics/diploma-other-training-centers/karmakanda-pourohitya-diploma" },
                    { name: "Astrology Diploma", link: "/en/academics/diploma-other-training-centers/jyotish-diploma" },
                    { name: "Yoga Diploma", link: "/en/academics/diploma-other-training-centers/yoga-diploma" },
                    { name: "Sanskrit Language Proficiency Diploma", link: "/en/academics/diploma-other-training-centers/sanskrit-language-proficiency-diploma" },
                    { name: "Gita Life Management Diploma", link: "/en/academics/diploma-other-training-centers/life-management-in-gita-diploma" },
                    { name: "English-Hindi-English Translation Diploma", link: "/en/academics/diploma-other-training-centers/english-hindi-english-translation-diploma" },
                ]
            },


            {
                name: "Activities",
                dropdown: [
                    { name: "NCC", link: "/en/academics/activities/ncc" },
                    { name: "NSS", link: "/en/academics/activities/nss" },
                    { name: "Sports & Games", link: "/en/academics/activities/sports" },
                    { name: "Cultural Activities", link: "/en/academics/activities/cultural" },
                ]
            },

            { name: "Academic Calendar", link: "/en/academics/academic-calendar" },
            { name: "Timetable", link: "/en/academics/timetable" },

            {
                name: "Curriculum", link: "/en/academic/curriculum"
                // dropdown: [
                //     { name: "Regular Courses", link: "/academics/courses/regular" },
                //     { name: "Part-time Courses", link: "/academics/courses/part-time" },
                // ]
            },

            { name: "Registered Research Scholars", link: "/en/academics/research-scholars" },
            { name: "Convocation", link: "/en/academics/convocation" },
        ]
    },

    { name: "Admissions", link: "/en/admissions" },
    { name: "Library", link: "/en/library" },
    { name: "Examinations", link: "/en/examinations" },
    {
        "name": "Facilities",
        "dropdown": [
            { "name": "Dormitory", link: "/en/facilities/dormitory" },
            { "name": "Guest House", link: "/en/facilities/guest-house" },
            { "name": "Health Center", link: "/en/facilities/health-center" },
            { "name": "Yajna Hall", link: "/en/facilities/yajna-hall" },
            { "name": "Computer Lab", link: "/en/facilities/computer-lab" },
            { "name": "Yoga Hall", link: "/en/facilities/yoga-hall" },
            { "name": "Sports Ground", link: "/en/facilities/sports-ground" },
            { "name": "Canteen", link: "/en/facilities/canteen" }
        ]
    },

    // {
    //     "name": "Press Releases & Tenders", "link": "en/press-releases-tenders"
    // },
    {
        "name": "NT", "link": "/en/notices-tenders"
    },
    // {
    //     "name": "Right to Information", "link": "en/right-to-information"
    // },
    {
        "name": "RTI", "link": "/en/right-to-information"
    },
    {
        "name": "Contact",
        "dropdown": [
            { "name": "Vice Chancellor's Office", "link": "/en/contact/vice-chancellor-office" },
            { "name": "Registrar's Office", "link": "/en/contact/registrar-office" },
            { "name": "University Officials", "link": "/en/contact/university-officials" },
            { "name": "Public Relations Officer (PRO) Office", "link": "/en/contact/public-relations-officer-office" },
            { "name": "Staff Directory", "link": "/en/contact/staff-directory" }
        ]
    },
    {
        "name": "Help", "link": "/en/help"
    },
    {
        "name": "Miscellaneous", "link": "/en/miscellaneous"
    },

];


const Navbar_Eng = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const [openSubDropdown, setOpenSubDropdown] = useState(null);
    const [openThirdDropdown, setOpenThirdDropdown] = useState(null);
    const [openFourthDropdown, setOpenFourthDropdown] = useState(null);

    return (
        <nav className="navbar">
            <ul className="nav-links">
                {menuItems.map((item, index) => (
                    <li key={index}
                        className="nav-item"
                        onMouseEnter={() => item.dropdown && setOpenDropdown(index)}
                        onMouseLeave={() => item.dropdown && setOpenDropdown(null)}
                    >
                        <a href={item.link}>{item.name}{item.dropdown && <i className="fas fa-caret-down ps-1"></i>}</a>

                        {item.dropdown && openDropdown === index && (
                            <ul className="dropdown">
                                {item.dropdown.map((subItem, subIndex) => (
                                    <li key={subIndex}
                                        className="dropdown-item"
                                        onMouseEnter={() => subItem.dropdown && setOpenSubDropdown(`${index}-${subIndex}`)}
                                        onMouseLeave={() => subItem.dropdown && setOpenSubDropdown(null)}
                                    >
                                        <a
                                            href={subItem.link}
                                            style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
                                        >
                                            {subItem.name}
                                            {subItem.dropdown && (
                                                <i
                                                    className="fas fa-caret-right"
                                                    style={{ marginLeft: "5px", color: "white" }}
                                                ></i>
                                            )}
                                        </a>
                                        {/* Nested Dropdown (Second Level) */}
                                        {subItem.dropdown && openSubDropdown === `${index}-${subIndex}` && (
                                            <ul className="sub-dropdown">
                                                {subItem.dropdown.map((nestedItem, nestedIndex) => (
                                                    <li key={nestedIndex}
                                                        className="nested-dropdown-item"
                                                        onMouseEnter={() => nestedItem.dropdown && setOpenThirdDropdown(`${index}-${subIndex}-${nestedIndex}`)}
                                                        onMouseLeave={() => nestedItem.dropdown && setOpenThirdDropdown(null)}
                                                    >
                                                        <a
                                                            href={nestedItem.link}
                                                            style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
                                                        >
                                                            {nestedItem.name}
                                                            {nestedItem.dropdown && (
                                                                <i
                                                                    className="fas fa-caret-right"
                                                                    style={{ marginLeft: "5px", color: "white" }}
                                                                ></i>
                                                            )}
                                                        </a>

                                                        {/* Third-Level Dropdown */}
                                                        {nestedItem.dropdown && openThirdDropdown === `${index}-${subIndex}-${nestedIndex}` && (
                                                            <ul className="third-dropdown">
                                                                {nestedItem.dropdown.map((thirdItem, thirdIndex) => (
                                                                    <li key={thirdIndex}
                                                                        onMouseEnter={() => thirdItem.dropdown && setOpenFourthDropdown(`${index}-${subIndex}-${nestedIndex}-${thirdIndex}`)}
                                                                        onMouseLeave={() => thirdItem.dropdown && setOpenFourthDropdown(null)}
                                                                    >
                                                                        <a href={thirdItem.link}>{thirdItem.name}{thirdItem.dropdown && <i className="fas fa-caret-right"></i>}</a>

                                                                        {/* Fourth-Level Dropdown */}
                                                                        {thirdItem.dropdown && openFourthDropdown === `${index}-${subIndex}-${nestedIndex}-${thirdIndex}` && (
                                                                            <ul className="fourth-dropdown">
                                                                                {/* Add your fourth-level dropdown items here */}
                                                                            </ul>
                                                                        )}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default Navbar_Eng;